import { createContext, useContext } from 'react';

// Catalogue des options (features_v2) servi par l'API
// (GET /super-admin/clients/features-catalog) : libellé et explication par
// chemin. Une option absente du catalogue est affichée sous un libellé déduit
// de son nom (voir humanizeKey) : on peut ajouter une option côté API sans
// toucher au front.

export const EMPTY_FEATURES_CATALOG = { features: {}, generic_labels: {} };

export const FeaturesCatalogContext = createContext(EMPTY_FEATURES_CATALOG);

export const useFeaturesCatalog = () => useContext(FeaturesCatalogContext);

export const FEATURE_SURFACE_LABELS = {
  backoffice: 'Back-office',
  mobile: 'Mobile',
  api: 'API',
  batch: 'Batch',
};

export const humanizeKey = (key) => {
  const words = key
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .trim()
    .toLowerCase();

  return words.charAt(0).toUpperCase() + words.slice(1);
};

const toPath = (path) => (Array.isArray(path) ? path.join('.') : path);

export const getFeatureEntry = (catalog, path) =>
  catalog?.features?.[toPath(path)] || null;

/**
 * Range des clés de premier niveau dans l'ordre du catalogue (Authentification,
 * Planification, …, Autres) : MySQL ne conserve pas l'ordre des clés JSON.
 * Les clés inconnues du catalogue passent à la fin, par ordre alphabétique.
 */
export const sortSectionKeys = (catalog, keys) => {
  const catalogKeys = Object.keys(catalog?.features || {});
  const rank = (key) => {
    const index = catalogKeys.indexOf(key);
    return index === -1 ? Number.MAX_SAFE_INTEGER : index;
  };

  return [...keys].sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
};

/**
 * Libellé d'une option : entrée du catalogue pour ce chemin, sinon libellé
 * générique de la clé (`required` → « Obligatoire »), sinon nom humanisé.
 */
export const getFeatureLabel = (catalog, path) => {
  const fullPath = toPath(path);
  const key = fullPath.split('.').pop();

  return (
    catalog?.features?.[fullPath]?.label ||
    catalog?.generic_labels?.[key] ||
    humanizeKey(key)
  );
};
